/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Comparison_Status_AddedInputs */

const id_builds_comparison_status_added = /** @type {(inputs: Builds_Comparison_Status_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ditambahkan`)
};

const ms_builds_comparison_status_added = /** @type {(inputs: Builds_Comparison_Status_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ditambah`)
};

const da_builds_comparison_status_added = /** @type {(inputs: Builds_Comparison_Status_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilføjet`)
};

const de_builds_comparison_status_added = /** @type {(inputs: Builds_Comparison_Status_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinzugefügt`)
};

const en_us2_builds_comparison_status_added = /** @type {(inputs: Builds_Comparison_Status_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Added`)
};

const es_es2_builds_comparison_status_added = /** @type {(inputs: Builds_Comparison_Status_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añadido`)
};

const es_mx2_builds_comparison_status_added = /** @type {(inputs: Builds_Comparison_Status_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añadido`)
};

const fil_builds_comparison_status_added = /** @type {(inputs: Builds_Comparison_Status_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idinagdag`)
};

const fr_builds_comparison_status_added = /** @type {(inputs: Builds_Comparison_Status_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouté`)
};

const it_builds_comparison_status_added = /** @type {(inputs: Builds_Comparison_Status_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiunto`)
};

const hu_builds_comparison_status_added = /** @type {(inputs: Builds_Comparison_Status_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hozzáadva`)
};

const nl_builds_comparison_status_added = /** @type {(inputs: Builds_Comparison_Status_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toegevoegd`)
};

const no_builds_comparison_status_added = /** @type {(inputs: Builds_Comparison_Status_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lagt til`)
};

const pl_builds_comparison_status_added = /** @type {(inputs: Builds_Comparison_Status_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dodane`)
};

const pt_br2_builds_comparison_status_added = /** @type {(inputs: Builds_Comparison_Status_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionado`)
};

const pt_builds_comparison_status_added = /** @type {(inputs: Builds_Comparison_Status_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionado`)
};

const ro_builds_comparison_status_added = /** @type {(inputs: Builds_Comparison_Status_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adăugat`)
};

const fi_builds_comparison_status_added = /** @type {(inputs: Builds_Comparison_Status_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lisätty`)
};

const sv_builds_comparison_status_added = /** @type {(inputs: Builds_Comparison_Status_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tillagd`)
};

const vi_builds_comparison_status_added = /** @type {(inputs: Builds_Comparison_Status_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã thêm`)
};

const tr_builds_comparison_status_added = /** @type {(inputs: Builds_Comparison_Status_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eklendi`)
};

const cs_builds_comparison_status_added = /** @type {(inputs: Builds_Comparison_Status_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přidané`)
};

const bg_builds_comparison_status_added = /** @type {(inputs: Builds_Comparison_Status_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добавени`)
};

const ru_builds_comparison_status_added = /** @type {(inputs: Builds_Comparison_Status_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добавлено`)
};

const uk_builds_comparison_status_added = /** @type {(inputs: Builds_Comparison_Status_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Додано`)
};

const ar_builds_comparison_status_added = /** @type {(inputs: Builds_Comparison_Status_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مضاف`)
};

const hi_builds_comparison_status_added = /** @type {(inputs: Builds_Comparison_Status_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जोड़े गए`)
};

const th_builds_comparison_status_added = /** @type {(inputs: Builds_Comparison_Status_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เพิ่มแล้ว`)
};

const ja_builds_comparison_status_added = /** @type {(inputs: Builds_Comparison_Status_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追加`)
};

const zh_cn2_builds_comparison_status_added = /** @type {(inputs: Builds_Comparison_Status_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新增`)
};

const zh_hant1_builds_comparison_status_added = /** @type {(inputs: Builds_Comparison_Status_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新增`)
};

const ko_builds_comparison_status_added = /** @type {(inputs: Builds_Comparison_Status_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`추가됨`)
};

/**
* | output |
* | --- |
* | "Added" |
*
* @param {Builds_Comparison_Status_AddedInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_comparison_status_added = /** @type {((inputs?: Builds_Comparison_Status_AddedInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Comparison_Status_AddedInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_comparison_status_added(inputs)
	if (locale === "ms") return ms_builds_comparison_status_added(inputs)
	if (locale === "da") return da_builds_comparison_status_added(inputs)
	if (locale === "de") return de_builds_comparison_status_added(inputs)
	if (locale === "en-US") return en_us2_builds_comparison_status_added(inputs)
	if (locale === "es-ES") return es_es2_builds_comparison_status_added(inputs)
	if (locale === "es-MX") return es_mx2_builds_comparison_status_added(inputs)
	if (locale === "fil") return fil_builds_comparison_status_added(inputs)
	if (locale === "fr") return fr_builds_comparison_status_added(inputs)
	if (locale === "it") return it_builds_comparison_status_added(inputs)
	if (locale === "hu") return hu_builds_comparison_status_added(inputs)
	if (locale === "nl") return nl_builds_comparison_status_added(inputs)
	if (locale === "no") return no_builds_comparison_status_added(inputs)
	if (locale === "pl") return pl_builds_comparison_status_added(inputs)
	if (locale === "pt-BR") return pt_br2_builds_comparison_status_added(inputs)
	if (locale === "pt") return pt_builds_comparison_status_added(inputs)
	if (locale === "ro") return ro_builds_comparison_status_added(inputs)
	if (locale === "fi") return fi_builds_comparison_status_added(inputs)
	if (locale === "sv") return sv_builds_comparison_status_added(inputs)
	if (locale === "vi") return vi_builds_comparison_status_added(inputs)
	if (locale === "tr") return tr_builds_comparison_status_added(inputs)
	if (locale === "cs") return cs_builds_comparison_status_added(inputs)
	if (locale === "bg") return bg_builds_comparison_status_added(inputs)
	if (locale === "ru") return ru_builds_comparison_status_added(inputs)
	if (locale === "uk") return uk_builds_comparison_status_added(inputs)
	if (locale === "ar") return ar_builds_comparison_status_added(inputs)
	if (locale === "hi") return hi_builds_comparison_status_added(inputs)
	if (locale === "th") return th_builds_comparison_status_added(inputs)
	if (locale === "ja") return ja_builds_comparison_status_added(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_comparison_status_added(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_comparison_status_added(inputs)
	return ko_builds_comparison_status_added(inputs)
});
export { builds_comparison_status_added as "builds.comparison.status.added" }